import { useEffect, useState } from 'react'

import { get, getFile, put, remove } from './vault'
import type { VaultEntry } from './vault'

// useVaultEntry reads what this device kept for a document. It returns
// undefined both while reading and when nothing was kept — the card shows the
// masked number either way, and only reveals more once there is more.
export function useVaultEntry(documentId: string | undefined): VaultEntry | undefined {
  const [entry, setEntry] = useState<VaultEntry>()

  useEffect(() => {
    let current = true

    void (documentId ? get(documentId) : Promise.resolve(undefined)).then((found) => {
      if (current) {
        setEntry(found)
      }
    })

    return () => {
      current = false
    }
  }, [documentId])

  return entry
}

// useKeepLocally hands back the two writes the upload flow needs, so a caller
// does not import the storage module directly to do one thing.
export function useKeepLocally(): {
  keep: (entry: { documentId: string; number?: string; file?: Blob; fileName?: string }) => void
  forget: (documentId: string) => void
} {
  return {
    keep: (entry) => void put(entry),
    forget: (documentId) => void remove(documentId),
  }
}

export function useLocalPreview(path: string | undefined): string | undefined {
  const [url, setUrl] = useState<string>()

  useEffect(() => {
    let current = true
    let created: string | undefined

    void (path ? getFile(path) : Promise.resolve(undefined)).then((found) => {
      if (!current) {
        return
      }

      created = found ? URL.createObjectURL(found) : undefined
      setUrl(created)
    })

    return () => {
      current = false

      if (created) {
        URL.revokeObjectURL(created)
      }
    }
  }, [path])

  return url
}
